<!-- Spinner while changes are being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the change list. Click below try again.
    <button hc-button size="lg" (click)="loadChanges()">Reload Changes</button>
</div>

<div class="admin-product-catalog-table-container" [hidden]="loadError || loading">
    <div class="pd-admin-editor-change-log">
        <h2>
            <div><hc-icon fontSet="fa" fontIcon="fa-history" hcIconMd></hc-icon> Change Log</div>
        </h2>
        <div class="admin-product-catalog-control-bar">
            <div class="admin-product-catalog-filters">
                <div class="filter-dropdown" title="Filter by product name">
                    <label for="item">Product</label>
                    <button hc-button buttonStyle="link-inline" id="name" [hcPop]="filtermenu"
                        (click)="storeFilterData('name')" [context]="productFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ productText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>
                <button hc-button hcDateRange title="Date Range" buttonStyle="link"
                    (selectedDateRangeChanged)="updateRange($event)" (selectedPresetChanged)="updatePreset($event)"
                    [selectedDate]="selected" [options]="options" class="filter-dropdown date-range">
                    <div class="date-range-filter-container"><span class="label">Date range</span>
                        <div><span class="value">
                                <span *ngIf="range.fromDate && range.toDate">
                                    {{ range.fromDate | date: 'MM/dd/yyyy' }} - {{ range.toDate | date: 'MM/dd/yyyy' }}
                                </span>
                                <span *ngIf="range.fromDate && !range.toDate">{{ range.fromDate | date: 'MM/dd/yyyy' }}
                                    or
                                    later</span>
                                <span *ngIf="!range.fromDate && range.toDate">{{ range.toDate | date: 'MM/dd/yyyy' }} or
                                    earlier</span>
                                <span *ngIf="!range.fromDate && !range.toDate">No dates selected</span>
                            </span>
                            <hc-icon fontSet="fa" fontIcon="fa-chevron-down" class="icon-right" hcIconSm></hc-icon>
                        </div>
                    </div>
                </button>
                <hc-pop #filtermenu scrollStrategy="close" (opened)="filterSelections = $event">
                    <filter-popover [filterData]="filterData" [setVals]="filterSelections" (close)="filtermenu.close()"
                        (filterChecked)="storeFilterArray($event)"></filter-popover>
                </hc-pop>
            </div>
            <div class="control-bar-right">
                <hc-search-bar #searchbar placeholder="Search changes" (triggerSearch)="applySearchFilter($event)"
                    class="admin-product-catalog-search"></hc-search-bar>
            </div>
        </div>
        <table hc-table [borders]="false" class="pd-admin-editor-change-log-table" [dataSource]="dataSource" hcSort>
            <!-- Date Column -->
            <ng-container hcColumnDef="date">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="dateHeader">Date</th>
                <td hc-cell *hcCellDef="let element">{{ element.date | date: 'shortDate' }}</td>
            </ng-container>

            <!-- Item ID Column -->
            <ng-container hcColumnDef="item-id">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="itemIDHeader">ID</th>
                <td hc-cell *hcCellDef="let element">{{ element.item }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container hcColumnDef="name">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Product</th>
                <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <!-- User Column -->
            <ng-container hcColumnDef="user">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="userHeader">User</th>
                <td hc-cell *hcCellDef="let element">{{ element.user }}</td>
            </ng-container>

            <!-- Field Column -->
            <ng-container hcColumnDef="field">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="fieldHeader">Field</th>
                <td hc-cell *hcCellDef="let element">{{ element.field }}</td>
            </ng-container>

            <!-- Previous Value Column -->
            <ng-container hcColumnDef="previous">
                <th hc-header-cell *hcHeaderCellDef id="fieldHeader">Previous Value</th>
                <td hc-cell *hcCellDef="let element">
                    <!-- For many to many fields where the value was 0 -->
                    <span *ngIf="manyFields.includes(element.field) && createObj(element.previous).length === 0">
                        {{ createObj(element.previous).length }}
                    </span>

                    <!-- For images where the value is > 0 -->
                    <button hc-button *ngIf="element.field === 'Images' && createObj(element.previous).length > 0"
                        [hcPop]="imageInfo" buttonStyle="link-inline">
                        {{ createObj(element.previous).length }}
                        <hc-pop #imageInfo scrollStrategy="close">
                            <div class="many-info-pop">
                                <div *ngFor="let img of createObj(element.previous); let i = index"
                                    class="many-info-el">
                                    <div class="many-info-el-index">{{ i + 1 }}</div>
                                    <div class="many-info-el-content">
                                        <div>
                                            <strong>File Name:</strong>
                                            {{ img.fileName }}
                                        </div>
                                        <div>
                                            <strong>Show in Data Sheet:</strong>
                                            {{ img.visibleInSheet }}
                                        </div>
                                        <div>
                                            <strong>Caption:</strong>
                                            {{ img.caption || '--' }}
                                        </div>
                                        <div>
                                            <strong>Type:</strong>
                                            {{ img.type }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </hc-pop>
                    </button>

                    <!-- For success stories where the value is > 0 -->
                    <button hc-button *ngIf="element.field === 'Success Stories' && createObj(element.previous).length > 0"
                        [hcPop]="caseStudyInfo" buttonStyle="link-inline">
                        {{ createObj(element.previous).length }}
                        <hc-pop #caseStudyInfo scrollStrategy="close">
                            <div class="many-info-pop">
                                <div *ngFor="let caseStudy of createObj(element.previous); let i = index"
                                    class="many-info-el">
                                    <div class="many-info-el-index">{{ i + 1 }}</div>
                                    <div class="many-info-el-content">
                                        <div>
                                            <strong>Title:</strong>
                                            {{ caseStudy.title }}
                                        </div>
                                        <div>
                                            <strong>URL:</strong>
                                            {{ caseStudy.url }}
                                        </div>
                                        <div *ngIf="caseStudy.metrics.length > 0" class="case-study-metrics">
                                            <strong>Metrics:</strong>
                                            <ol>
                                                <li *ngFor="let metric of caseStudy.metrics"
                                                    [innerHTML]="metric.name | sanitizeHtml">
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </hc-pop>
                    </button>

                    <!-- For icons -->
                    <span *ngIf="element.field === 'Icons'">
                        <div *ngIf="createObj(element.previous)['svgURL']" class="icon-url"><strong>SVG URL: </strong>
                            {{
                            createObj(element.previous)['svgURL'] }} </div>
                        <div *ngIf="createObj(element.previous)['pngURL']" class="icon-url"><strong>PNG URL: </strong>
                            {{
                            createObj(element.previous)['pngURL'] }} </div>
                        <div *ngIf="createObj(element.previous)['base64URL']" class="icon-url"><strong>Base64 URL:
                            </strong>
                            {{
                            createObj(element.previous)['base64URL'] }} </div>
                    </span>

                    <!-- For previous names, apps, services where the value is > 0 -->
                    <span *ngIf="
                            (element.field === 'Included Technology' ||
                                element.field === 'Associated Services') || element.field === 'Previous Names' &&
                            createObj(element.previous).length > 0
                        ">
                        <ul>
                            <li *ngFor="let name of createObj(element.previous)">{{ name }}</li>
                        </ul>
                    </span>

                    <!-- For html fields -->
                    <span hc-button *ngIf="htmlFields.includes(element.field) && element.previous.length > 0"
                        [innerHTML]="element.previous | ellipsis : 50 | sanitizeHtml" [hcPop]="htmlOverflow"
                        [trigger]="element.previous.length > 100 ? 'hover' : 'none'">
                        <hc-pop #htmlOverflow scrollStrategy="close">
                            <div class="html-popover" [innerHTML]="element.previous | sanitizeHtml"></div>
                        </hc-pop>
                    </span>
                    <span *ngIf="htmlFields.includes(element.field) && element.previous.length === 0">--</span>

                    <!-- For id fields -->
                    <span *ngIf="idFields.includes(element.field)">
                        {{ formatID(element.previous, element.field) || '--' }}
                    </span>

                    <!-- For all other fields -->
                    <span
                        *ngIf="!manyFields.includes(element.field) && !htmlFields.includes(element.field) && !idFields.includes(element.field) && element.field !== 'Icons'">
                        {{ element.previous || '--' }}
                    </span>
                </td>
            </ng-container>

            <!-- Change Value Column -->
            <ng-container hcColumnDef="change">
                <th hc-header-cell *hcHeaderCellDef id="fieldHeader">Change Value</th>
                <td hc-cell *hcCellDef="let element">
                    <!-- For many to many fields where the value was 0 -->
                    <span *ngIf="manyFields.includes(element.field) && createObj(element.update).length === 0">
                        {{ createObj(element.update).length }}
                    </span>

                    <!-- For images where the value is > 0 -->
                    <button hc-button *ngIf="element.field === 'Images' && createObj(element.update).length > 0"
                        [hcPop]="imageInfo" buttonStyle="link-inline">
                        {{ createObj(element.update).length }}
                        <hc-pop #imageInfo scrollStrategy="close">
                            <div class="many-info-pop">
                                <div *ngFor="let img of createObj(element.update); let i = index" class="many-info-el">
                                    <div class="many-info-el-index">{{ i + 1 }}</div>
                                    <div class="many-info-el-content">
                                        <div>
                                            <strong>File Name:</strong>
                                            {{ img.fileName }}
                                        </div>
                                        <div>
                                            <strong>Show in Data Sheet:</strong>
                                            {{ img.visibleInSheet }}
                                        </div>
                                        <div>
                                            <strong>Caption:</strong>
                                            {{ img.caption || '--' }}
                                        </div>
                                        <div>
                                            <strong>Type:</strong>
                                            {{ img.type }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </hc-pop>
                    </button>

                    <!-- For success stories where the value is > 0 -->
                    <button hc-button *ngIf="element.field === 'Success Stories' && createObj(element.update).length > 0"
                        [hcPop]="caseStudyInfo" buttonStyle="link-inline">
                        {{ createObj(element.update).length }}
                        <hc-pop #caseStudyInfo scrollStrategy="close">
                            <div class="many-info-pop">
                                <div *ngFor="let caseStudy of createObj(element.update); let i = index"
                                    class="many-info-el">
                                    <div class="many-info-el-index">{{ i + 1 }}</div>
                                    <div class="many-info-el-content">
                                        <div>
                                            <strong>Title:</strong>
                                            {{ caseStudy.title }}
                                        </div>
                                        <div>
                                            <strong>URL:</strong>
                                            {{ caseStudy.url }}
                                        </div>
                                        <div *ngIf="caseStudy.metrics.length > 0" class="case-study-metrics">
                                            <strong>Metrics:</strong>
                                            <ol>
                                                <li *ngFor="let metric of caseStudy.metrics"
                                                    [innerHTML]="metric.name | sanitizeHtml">
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </hc-pop>
                    </button>

                    <!-- For icons -->
                    <span *ngIf="element.field === 'Icons'">
                        <div *ngIf="createObj(element.update)['svgURL']" class="icon-url"><strong>SVG URL: </strong> {{
                            createObj(element.update)['svgURL'] }} </div>
                        <div *ngIf="createObj(element.update)['pngURL']" class="icon-url"><strong>PNG URL: </strong> {{
                            createObj(element.update)['pngURL'] }} </div>
                        <div *ngIf="createObj(element.update)['base64URL']" class="icon-url"><strong>Base64 URL:
                            </strong>
                            {{
                            createObj(element.update)['base64URL'] }} </div>
                    </span>

                    <!-- For previous names, apps, services where the value is > 0 -->
                    <span *ngIf="
                (element.field === 'Included Technology' ||
                    element.field === 'Associated Services') || element.field === 'Previous Names' &&
                createObj(element.update).length > 0
                ">
                        <ul>
                            <li *ngFor="let name of createObj(element.update)">{{ name }}</li>
                        </ul>
                    </span>

                    <!-- For html fields -->
                    <span hc-button *ngIf="htmlFields.includes(element.field) && element.update.length > 0"
                        [innerHTML]="element.update | ellipsis : 50 | sanitizeHtml" [hcPop]="htmlOverflow"
                        [trigger]="element.update.length > 100 ? 'hover' : 'none'">
                        <hc-pop #htmlOverflow scrollStrategy="close">
                            <div class="html-popover" [innerHTML]="element.update | sanitizeHtml"></div>
                        </hc-pop>
                    </span>
                    <span *ngIf="htmlFields.includes(element.field) && element.update.length === 0">--</span>

                    <!-- For id fields -->
                    <span *ngIf="idFields.includes(element.field)">
                        {{ formatID(element.update, element.field) || '--' }}
                    </span>

                    <!-- For all other fields -->
                    <span
                        *ngIf="!manyFields.includes(element.field) && !htmlFields.includes(element.field) && !idFields.includes(element.field) && element.field !== 'Icons'">
                        {{ element.update || '--' }}
                    </span>
                </td>
            </ng-container>

            <tr hc-header-row *hcHeaderRowDef="displayedColumns"></tr>
            <tr hc-row *hcRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <hc-pagination [length]="listLength" [pageSize]="pageSize" [hidden]="loadError || loading"></hc-pagination>
    </div>
</div>